import { styled } from '@mui/material/styles';

export const ImageComponent = styled('img')<{ imageLoaded: boolean }>((imageLoaded) => ({
  transition: 'opacity 0.5s',
  opacity: imageLoaded ? 1 : 0,
}));
